/**
 * http://usejsdoc.org/
 */
import React, { Component } from 'react';
import {
 Col, Row, Label
} from 'reactstrap';
import { LocalForm } from 'react-redux-form';
import jumperStore from '../../../stores/jumpers-store';
import AdminModal from '../modals/customModal';

class RemoveCard extends Component {

    constructor(props) {
        super(props);
        this.state={
          isModalOpen: false,
        }
        this.jumperEvents = [
            { name: jumperStore.getEventPrefix('deleteCardEvent'), func: this.handleDeleteCard },
        ];
    }
    componentDidMount = () => {
        this.jumperEvents.forEach((evnt) => jumperStore.on(evnt.name, evnt.func));
    }
    componentWillUnmount = () => {
        this.jumperEvents.forEach((evnt) => jumperStore.removeListener(evnt.name, evnt.func));
    }
    toggleModal = (e) => {
        this.setState({
            isModalOpen: !this.state.isModalOpen,
        });
        // this.props.cardsHandler();
    }
    handleDeleteCard = (jumper) => {
        //after deleted from database
        // this.toggleModal();
        this.setState({
            isModalOpen: false
        })
    }
    handleSubmit = (jumperId,cardId) => {
         jumperStore.removeCardOnFile(jumperId,cardId);
    }


    render() {
        //const { } = this.props.jumperDetail;
        return (
            <React.Fragment>
                <AdminModal
                    isModalOpen={this.state.isModalOpen}
                    title={`Remove Card`}>
                    <LocalForm onSubmit={(e) => this.handleSubmit(this.props.jumperId,this.props.cardId)}>
                        <Row className="form-group">
                            <Label htmlFor="pilot" md={12}>
                                Are you sure you want to remove card on file
                            </Label>
                        </Row>
                        <Row className="form-group m-t-2-rem">
                            <Col md={{ size: 10 }}>
                                <button className="btn btn-bg lightColor createButton" type="submit" >
                                    SUBMIT
                                </button>
                                <button onClick={(e) => { e.preventDefault(); this.toggleModal(); }} className="btn btn-link">
                                    CANCEL
                                </button>
                            </Col>
                        </Row>
                    </LocalForm>
                </AdminModal>

                <span onClick={this.toggleModal} style={{cursor:'pointer'}}>
                    <i className="fa fa-trash" style={{fontSize:'23px'}}></i>
                </span>
            </React.Fragment>
        );
    }
}

export default RemoveCard
